import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getTrade } from "../../utils/contractHelpers";
// import { useWeb3React } from "@web3-react/core";
import { userSmartAccount } from "../../components/RecoilAtom";
import { useRecoilValue } from "recoil";

const BalanceOfBatch = () => {
    const web3 = useWeb3();
    const smartAccount = useRecoilValue(userSmartAccount)

    const BalanceOfBatchHook = useCallback(
        async (address, choiceIndex) => {
            const contract = getTrade(address, web3);
            try {
                const balanceofbatch = await contract.methods.userVotes(choiceIndex, smartAccount).call();
                return balanceofbatch;
            } catch (error) {
                console.error("Error fetching balance:", error.message || error);
                throw error;
            }
        },
        [web3, smartAccount]
    );

    return { BalanceOfBatchHook };
};

export default BalanceOfBatch;



